module.exports = __webpack_public_path__ + "static/git-9adb24ddf43f0517a616276191e97774.png";